module.exports = __webpack_public_path__ + "img/qilin-f-stage5-hungry.3a95221b.png";